__turbopack_context__.v({
  "playButton": "VideoSlide-module-scss-module___7Jd6W__playButton",
  "preview": "VideoSlide-module-scss-module___7Jd6W__preview",
  "readMoreBtn": "VideoSlide-module-scss-module___7Jd6W__readMoreBtn",
  "thumbnail": "VideoSlide-module-scss-module___7Jd6W__thumbnail",
  "video": "VideoSlide-module-scss-module___7Jd6W__video",
  "videoContainer": "VideoSlide-module-scss-module___7Jd6W__videoContainer",
  "videoFullscreen": "VideoSlide-module-scss-module___7Jd6W__videoFullscreen",
});
